import React, { useState } from 'react';
import { Box, Typography, Pagination } from '@mui/material';
import {
    GestionFermetureEtablissementWidget,
    GestionFermetureEtablissementWidgetType,
} from '../../molecules';

export type GestionFermetureEtablissementListProps = {
    items?: Array<GestionFermetureEtablissementWidgetType>;
};

const ITEMS_PER_PAGE = 10;

export const GestionFermetureEtablissementList: React.FunctionComponent<GestionFermetureEtablissementListProps> =
    function (props: GestionFermetureEtablissementListProps) {
        const { items } = props;
        const [page, setPage] = useState(1);

        if (!items || items.length === 0) {
            return (
                <Typography
                    variant="body1"
                    sx={{ marginTop: '16px', color: 'text.secondary', fontStyle: 'italic' }}
                >
                    Aucun établissement secondaire existant
                </Typography>
            );
        }

        const hasClosedEtablissement = items.some(
            (item) =>
                item.gestionFermetureEtablissement?.personneMorale?.autresEtablissements
                    ?.descriptionEtablissement?.dateEffetFermeture,
        );

        const visibleItems = hasClosedEtablissement
            ? items
                  .map((item, originalIndex) => ({ item, originalIndex }))
                  .filter(
                      ({ item }) =>
                          item.gestionFermetureEtablissement?.personneMorale?.autresEtablissements
                              ?.descriptionEtablissement?.dateEffetFermeture,
                  )
            : items.map((item, originalIndex) => ({ item, originalIndex }));

        const totalPages = Math.ceil(visibleItems.length / ITEMS_PER_PAGE);
        const paginatedItems = visibleItems.slice(
            (page - 1) * ITEMS_PER_PAGE,
            page * ITEMS_PER_PAGE,
        );

        return (
            <Box>
                {paginatedItems.map(({ item: itemProps, originalIndex }) => (
                    <GestionFermetureEtablissementWidget
                        key={`gestionFermetureEtablissement-${originalIndex}`}
                        {...itemProps}
                        index={originalIndex}
                    />
                ))}
                {totalPages > 1 && (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '16px',
                        }}
                    >
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={(_, value) => setPage(value)}
                            color="primary"
                            shape="rounded"
                        />
                    </Box>
                )}
            </Box>
        );
    };
